import { DELETE, GET_LIST, UPDATE } from "react-admin";
import { Options, buildDataProvider } from "@ra-data-prisma/dataprovider";
import { useEffect, useState } from "react";

import dayjs from "dayjs";
import withAuthProvider from "./authProvider";

export const appProvidersFactory = () => {
  return (options: Options) => {
    const [dataProvider, setDataProvider] = useState<any>();
    const authProvider = withAuthProvider();

    useEffect(() => {
      buildDataProvider(options)
        .then((p) => {
          setDataProvider(() => p);
        })

        .catch((e) => {
          console.error(e);
        });
    }, []);

    const getDataProvider = (type: string, resource: string, params: any) => {
      if (!dataProvider) return false;

      const _params = JSON.parse(JSON.stringify(params));

      if (type === DELETE && ["User", "Company"].includes(resource)) {
        return dataProvider(UPDATE, resource, {
          data: {
            id: params.id,
            deletedAt: new Date(),
          },
        });
      }

      if (type === GET_LIST && resource === "DeliveryNote") {
        if (params?.filter?.confirmedAt) {
          if (params?.filter?.confirmedAt === "CONFIRMED") {
            _params.filter.confirmedAt = {
              not: null,
            };
          } else if (params?.filter?.confirmedAt === "NOT_CONFIRMED") {
            _params.filter.confirmedAt = {
              equals: null,
            };
          }
        }

        if (params?.filter?.order?.loadingDate_gte) {
          _params.filter.order.loadingDate_gte = dayjs(
            params?.filter?.order?.loadingDate_gte,
          )
            .subtract(2, "hours")
            .format("YYYY-MM-DD HH:mm");
        }
        if (params?.filter?.order?.unloadingDate_gte) {
          _params.filter.order.unloadingDate_gte = dayjs(
            params?.filter?.order?.unloadingDate_gte,
          )
            .subtract(2, "hours")
            .format("YYYY-MM-DD HH:mm");
        }
      }

      if (type === GET_LIST && resource === "Order") {
        if (params?.filter?.loadingDate_gte) {
          _params.filter.loadingDate_gte = dayjs(
            params?.filter?.loadingDate_gte,
          )
            .subtract(2, "hours")
            .format("YYYY-MM-DD HH:mm");
        }
        if (params?.filter?.unloadingDate_gte) {
          _params.filter.unloadingDate_gte = dayjs(
            params?.filter?.unloadingDate_gte,
          )
            .subtract(2, "hours")
            .format("YYYY-MM-DD HH:mm");
        }
        if (params?.filter?.hasOwnProperty("caveats")) {
          // if (params.filter.caveats === true) {
          //   _params.filter.caveats = {
          //     some: {}
          //   };
          // }
          // if (params.filter.caveats === false) {
          //   _params.filter.caveats = {
          //     none: {}
          //   };
          // }
          // delete _params.filter.hasCaveats;
        }
      }

      if (type === GET_LIST && resource === "Location") {
        if (params?.filter?.city) {
          _params.distinct = ["town"];
          delete _params.filter.city;
        }
      }

      return dataProvider(type, resource, _params);
    };

    return {
      dataProvider: dataProvider && getDataProvider,
      authProvider,
    };
  };
};
